import { render, staticRenderFns } from "./dialogImpersonate.vue?vue&type=template&id=a6a4ff00&"
import script from "./dialogImpersonate.vue?vue&type=script&lang=js&"
export * from "./dialogImpersonate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports